import Axios from "@/models/axios";

class SubscriptionApi extends Axios {
/*
  constructor(data, config) {
    super();
    this.data    = data;
    this.config  = config;
    this.baseUrl = 'https://publish.ne.cision.com';
  }
*/

  path() {
    return `Subscription`
  }
}

export default SubscriptionApi;
